import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import useUserStore from "../../../services/userStore";
import axios from "axios";
import { NGROK } from "../../../APIs";
import { myLocalStorage } from "../../../components/StorageHelper";
import AzureDeviceItem from "./Components/AzureDeviceItem";
import SyncIcon from "@mui/icons-material/Sync";
import TailwinButton from "../../../tailwind-ui/components/TailwinButton";
import TailwindLoadingSpinner from "../../../tailwind-ui/components/TailwindLoadingSpinner";
import TailwindTable from "../../../tailwind-ui/components/TailwindTable";
import TailwindFilterHeader from "../../../tailwind-ui/components/TailwindFilterHeader";
import { triggerCloudSync } from "../../../triggerCloudSync";
import useCloudSyncStore from "../../../services/useCloudSyncStore";
import useNotificationStore from "../../../services/notificationStore";

const AzureDevices = () => {
  const [selectedTenantName, setSelectedTenantName] = useState(null);
  const userData = useUserStore((state) => state.user);
  const [tenantList, setTenantList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [devices, setDevices] = useState(null);
  const [isSyncing, setIsSyncing] = useState(null);
  const syncStatus = useCloudSyncStore((state) => state.syncStatus);
  let { azureConfig } = useNotificationStore.getState();

  const demandSync = async () => {
    try {
      const data = await triggerCloudSync(
        "azure",
        "/api/azure-sync/onDemand",
        selectedTenantName,
      );
      console.log("Azure Sync complete:", data);
    } catch (error) {
      console.error("Azure Sync failed", error);
    }
  };

  const handleTenantChange = (value) => {
    const tenant = tenantList.find((tenant) => tenant.tenantName === value);
    if (tenant !== undefined) {
      setSelectedTenantName(tenant.tenantName);
      myLocalStorage.setItem("latestTenant", tenant);
    }
  };
  const fetchAzureDevices = async (isFirst = false) => {
    try {
      if (isFirst) {
        setLoading(true);
      }
      const response = await axios.get(
        `${NGROK}/api/azure/v1/devices?tenantName=${selectedTenantName}`,
      );
      if (response?.data) {
        setDevices(response?.data);
      }
    } catch (e) {}

    setLoading(false);
  };
  useEffect(() => {
    if (tenantList.length === 1)
      return setSelectedTenantName(tenantList[0].tenantName);

    if (tenantList?.length > 1) {
      const latestTenantName =
        myLocalStorage.getItem("latestTenant")?.tenantName;

      const tenant = tenantList.find(
        (tenant) => tenant.tenantName === latestTenantName,
      );
      if (tenant) setSelectedTenantName(tenant.tenantName);
      else setSelectedTenantName(tenantList[0].tenantName);
    }
  }, [tenantList]);
  useEffect(() => {
    const fetchTenants = async () => {
      const response = await axios.get(`${NGROK}/api/get-all-domains`);
      setTenantList(response.data);
    };
    fetchTenants();
  }, [userData]);
  useEffect(() => {
    if (!selectedTenantName) return;
    fetchAzureDevices(true);
    const interval = setInterval(() => {
      fetchAzureDevices();
    }, 5000);
    return () => clearInterval(interval);
  }, [selectedTenantName]);

  const renderDeviceDetails = (devices, colIndex, col) => {
    switch (colIndex) {
      case 0:
        return (
          <div className="space-y-4">
            {devices?.map((device, index) => (
              <div key={device.id || index} className="p-4 rounded-md">
                <AzureDeviceItem device={device} />
              </div>
            ))}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="p-4">
        <TailwindFilterHeader
          title="Azure Devices"
          dropdowns={[
            {
              label: "Tenant",
              value: selectedTenantName,
              options: tenantList.map((t) => ({
                label: t.tenantName,
                value: t.tenantName,
              })),
              onChange: handleTenantChange,
            },
          ]}
          tabs={[]}
          isSyncing={syncStatus["azure"]}
          onSync={demandSync}
          isSyncNeeded={azureConfig ? true : false}
        />

        <TailwindTable
          columns={["Devices"]}
          data={[devices]}
          renderCell={renderDeviceDetails}
          isSelected={null}
          needLoading={false}
        />
      </div>
    </>
  );
};

export default AzureDevices;
